import { ENVIRONMENTS, getEnvFromHostname } from '../pages/utils/getEnvFromHostname';

// The portal SDK only ships 'production' and 'development' tracking pipelines;
// staging and localhost both route through 'development'.
export const getTrackingEnvironment = () =>
  getEnvFromHostname() === ENVIRONMENTS.PRODUCTION
    ? ENVIRONMENTS.PRODUCTION
    : ENVIRONMENTS.DEVELOPMENT;
